module.exports = __webpack_public_path__ + "static/media/reupload-cancel.a1bb3953.svg";